import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {TableActionMenu} from "~/ui/ActionMenu/ActionMenu";

import { Button, Divider, HStack, Tooltip, } from "~/native-ui"
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';

class TableActions extends Component {
	static propTypes = {
        modelId: PropTypes.string.isRequired,
        onAdd: PropTypes.func.isRequired,
        canCreate: PropTypes.bool.isRequired,
		addText: PropTypes.string.isRequired,
        createTooltip: PropTypes.string,
		isSmallScreen: PropTypes.bool,
	};
	

	renderActions() {
		return (
			<HStack alignItems="center">
                <TableActionMenu modelId={this.props.modelId} />

				<React.Fragment>{this.props.canCreate && <Divider orientation="vertical" bg="coolGray.300" h="5" mx="2" />}</React.Fragment>

				<React.Fragment>
					{
						this.props.canCreate && 
						<Tooltip tooltip={this.props.addText}>
							<Button
								icon="add"
								primary
								iconSize="sm"
								onPress={this.props.onAdd}
							/>
						</Tooltip>
					}
				</React.Fragment>
			</HStack>
		);
	}


	onAdd = (...args) => {
		return this.props.onAdd?.(...args);
	}

	dropdownActions = [{
		action: this.onAdd,
		caption: this.props.addText,
		groupName: 'primary',
		disabled: false,
		isActive: false,
		group: {
			name: 'primary',
			icon: "add",
			order: -1,
			title: this.props.addText,
		},
		hasPermission: true,
		value: ""
	}]

	renderActionsDropdown() {
		if (!this.props.canCreate) return null;
		return <TableActionMenu modelId={this.props.modelId} dropdownMode actions={this.dropdownActions} />;
	}

	render() {
		return this.props.isSmallScreen ? this.renderActionsDropdown() : this.renderActions();
	}
}

export default withResponsiveFlags(TableActions, {
	includeKeys: ['isSmallScreen']
})